import React from "react";
import Cable from "./Dropwire";
import { UAParser } from "ua-parser-js";

export default class Basic extends React.Component {
  constructor(props) {
    super(props);
    var parser = new UAParser();
    const name = parser.getBrowser().name;
    console.log(name);
    this.state = {
      onFactors: true,
      trigger: false,
      browser: name,
      scrollTop: 0,
      serviceCancelingImages: name.includes("Safari")
    };
    for (let i = 0; i < 220; i++) {
      this["scrollImg" + i] = React.createRef();
    }
    this.plaintiff = React.createRef();
    this.utility = React.createRef();
    this.cops = React.createRef();
  }
  componentDidMount = () => {
    this.handleScroll();
    window.addEventListener("resize", this.refresh);
    window.addEventListener("scroll", this.handleScroll);
    this.refresh(true);
    const { pathname } = this.props;
    clearTimeout(this.starttime);
    this.starttime = setTimeout(() => {
      this.check(pathname);
    }, 500);
  };
  check = (pathname) => {
    if (pathname === "/plaintiff") {
      window.scroll(0, this.plaintiff.current.offsetTop);
    } else if (pathname === "/utility") {
      this.setState(
        {
          onFactors: false,
          onVaumoney: false
        },
        () => window.scroll(0, this.utility.current.offsetTop)
      );
    } else if (pathname === "/cops") {
      this.setState(
        {
          onFactors: false,
          onVaumoney: true
        },
        () => window.scroll(0, this.cops.current.offsetTop)
      );
    }
  };
  componentDidUpdate = (prevProps) => {
    const { pathname, basic } = this.props;
    if (
      this.props !== prevProps ||
      basic !== prevProps.basic ||
      pathname !== prevProps.pathname
    ) {
      this.check(pathname);
    }
  };
  componentWillUnmount = () => {
    clearTimeout(this.starttime);
    clearTimeout(this.scrollTimeout);
    clearTimeout(this.resizeTimer);
    window.removeEventListener("resize", this.refresh);
    window.removeEventListener("scroll", this.handleScroll);
  };
  handleScroll = (e) => {
    if (!this.state.offScroll) {
      const scrollTop = window.scrollY;
      this.setState(
        {
          scrolling: true,
          scrollTop
        },
        () => {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            this.setState({
              scrolling: false
            });
          }, 900);
        }
      );
    } //"abolish exchange value" - CJ
    //social capital estranged from the rollover/expiry individual
    //govrent assert the universal. "'capitaism is small gov ad freedom' so much no"
  }; //authority is unique for payment for the transaction requires it,
  //but for instance a distributed database for a death registry, would not
  //acheive trustlessness by the same methods
  refresh = (first) => {
    const width =
      (this.state.ios ? window.screen.availWidth : window.innerWidth) - 20;
    if (first || Math.abs(this.state.lastWidth - width) > 0) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.setState({
          lastWidth: width,
          width,
          availableHeight: this.state.ios
            ? window.screen.availHeight - 20
            : window.innerHeight
        });
      }, 600);
    }
  };
  render() {
    const handleScollImgError = (e) => {
      if (e.message) {
        console.log(e.message);
        this.setState({ serviceCancelingImages: true });
      }
    };
    let arrayOfnumbers = 0;
    const scrollnum = () => {
      arrayOfnumbers = arrayOfnumbers + 1; //arrayOfnumbers[arrayOfnumbers.length - 1] + 1;
      //arrayOfnumbers.push(num);
      //console.log(arrayOfnumbers)
      return arrayOfnumbers;
    };
    const space = " ";
    if (this.state.onFactors) {
      return (
        <div
          style={{
            border: "1px solid rgb(200,200,200)",
            overflow: "hidden",
            //margin: "5px",
            fontFamily: "'Comfortaa', cursive",

            wordBreak: "break-word",
            textAlign: "left",
            width: "100%",
            maxWidth: "600px",
            position: "relative",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              position: "fixed", //salt bank vaults royalty stewardship
              right: "0px", //living commodities at the equator
              top: "0px", //"manipulation of credit system is by we are here"
              cursor: "pointer" //general payday loans are exclusionary
              //no longer boycotting credit (forced investment to bank)
              //Isn't forced investment banking exclusionary?
              //you can't teach resonsibility with ed tech
              //work at 9
            }}
            onClick={() => this.setState({ onFactors: false })}
          >
            back
            {/**i think satan is certain is anything (believe if anything) 
            
            ​do you make more than $10,275? Hoo boy do I need life insurance registered agents

            ​danger to oneself is in the eye of the beholder or consensus?

           binary plaintiff democracy isn't always that way

           money velocity or tax rate subs [dude]

           metaphorical ass beating-null: general maintenance consensus industry variability exclusion

           life insurance account

           emergency doctors on the calendar

           only medics

           it's greatfor the ratings [it's the best]

           echoing spells (tokyo ghoul: salmon) "one and done"

           the colors can be made expensive

           retard by action
            */}
          </div>
          <h2>
            <a
              style={{ color: "black" }}
              href="https://islam.stackexchange.com/questions/77747/is-sharia-law-enough-for-janna-on-earth"
            >
              Heaven
            </a>
            {space}is Earth
          </h2>
          Wow,{space}
          <a style={{ color: "black" }} href="https://jester.com.co">
            never go full choir boy
          </a>
          , to appease{space}
          <span style={{ textDecoration: "line-through" }}>a</span>
          {space}the G-d that wants what your people want.
          <h4 style={{ margin: "4px 0px" }}>
            <a style={{ color: "black" }} href="https://humanharvest.info">
              Atone for and leave your vaccine polytheism by cardiology-baths
            </a>
          </h4>
          <div
            style={{
              padding: "10px",
              backgroundColor: "rgb(252, 255, 179)"
            }}
          >
            He has only forbidden you ˹to eat˺ carrion, blood, swine, and what
            is slaughtered in the name of any other than Allah. But if someone
            is compelled by necessity—neither driven by desire nor exceeding
            immediate need—they will not be sinful. Surely Allah is
            All-Forgiving, Most Merciful. (2:173)
          </div>
          How do transubstantiation and sin sacrifice differ? Does vicarious
          animal sacrifice work for the Hebrew-Arabic or Jewish as G-d in in the
          flesh does for Him in either Catholicism or Christianity?
          <br />
          <br />
          <i>
            I literally don't have time for{space}
            <a style={{ color: "black" }} href="https://bankingisnot.biz">
              this
            </a>
            .
          </i>
          <br />
          They want us to say what we don't protect covalently with short{space}
          <a href="https://brainscan.info" style={{ color: "black" }}>
            time
          </a>
          .
          <br />
          <br />
          <a
            style={{ color: "black" }}
            href="https://islamicbanks.quora.com/Would-a-third-party-donee-beneficiary-be-damaged-if-the-insurance-games-payout-warranty-denomination-commodity-is-secur-1"
          >
            Intractable, intertemporal returns; disburse joint
          </a>
          {space}all at once claims cash or in kind less surrendered
          overtime-tort.
          <h2>
            "How On Earth Do{space}
            <a style={{ color: "black" }} href="https://vau.money/login">
              Finances
            </a>
            {space}Work from an Islamic POV?"
          </h2>
          <div
            style={{
              padding: "10px",
              backgroundColor: "lightsalmon"
            }}
          >
            The U.S. Code 26 Section 2503 (e) permits out of pocket direct
            literal savings accounts that are tax-free if not by either present
            or future interest of your unincorporated association mcc-qualified
            transfer material-subcontractor purpose trust then by 1031 advance
            nonsale exchange at worse at least by customer-base size. Please
            wait a few weeks and sign up with my service for this payable
            account for you at vau.money/login, for when I use live Stripe
            Connect payment intents which unfortunately confirms still t+
            payment intent payouts from haram banks. The U.S. allows transfers
            and daily cash withdrawal limits from safe deposit boxes though, my
            fellow plebeian. The financial benefactor is cardinal, never an
            absolute material benefit, sheer marginal utility and only ordinal
            after the liquid goods for capital deflates justly by some whatever
            lag.
            <br />
            <br />
            Also, Hadith/Qawliyyah is the most important and credible as a
            matter of what was admitted by Muhammad (pbuh), let alone habits/Al
            Filiyya and “silent approvals”/Taqririyyah perhaps being covalent
            being just as suspect in binding historical accounts practically and
            legally. If verbal confirmation consensus were easier sworn
            testimony would be bullocks and not even capable to invoke perjury
            by duress, and subsequent parachutes for lesser sentences.
            <br />
            <br />
            FWIU Al Rayan bank lends deposits by the fixed game of either debt
            service and foreclosure or implausible use lease, and just doesn’t
            give you the return. My statement also works for you being denied
            whatever a “current account” is.
          </div>
          <h1>Ordinary calling cards</h1>
          Are invoices to sole proprietors not in context?
          <br />
          <br />
          <a href="https://multilevelcapital.com" style={{ color: "black" }}>
            Do gift card advance acquisitions or estimate-invoice certificate
            procurements subject labor to consumer fraud penalties? Does
            insurance-warranty advance and estimate-invoice bill labor or
            employer liability protect consumers from contract fraud?
          </a>
          <br />
          <br />
          The ruling by who? I am positive that democracy is Islamic by 2:282,
          any tort so espoused by your invoices are backed by democracy of
          scribes, whom have no involvement from an immediate trade, or merchant
          category nonsale advance, which is made by your loan. A western court
          would garnish income in a specific industry, without incurring a
          non-partnership cost of value nominal instead of percentage coupon, a
          labor third party donee beneficiary otherwise.
          <h3>
            Tort{space}
            <a style={{ color: "black" }} href="https://micro-theory.com">
              benefactors
            </a>
            {space}notwithstanding
            {/**foreign direct imports, dollar interior vote, reconciliation duress, tax security first */}
          </h3>
          Industry proprietor interest fee loans does just that - no living
          costs inflated, only deflationary, technical competition
          <br />
          <i>Warranty is not a full partnership but a</i>
          {space}labor contract
          <h2>
            Direct, out-of-pocket - the neck{/**indusry proprietor payday */}
          </h2>
          <h4>
            Either loss or intractable{space}
            <a style={{ color: "black" }} href="https://vau.money/login">
              shareholder loans over direct out-of-pocket payments
            </a>
            {space}will put you in Hell.
            <div
              style={{
                padding: "10px",
                backgroundColor: "rgb(252, 255, 179)"
              }}
            >
              "give less when [you] measure or weigh for buyers [of plaintiff
              value; (Can we stop public debt for private value?)]." (83:3)
            </div>
          </h4>
          Claims must be inventory-extractable to be fair, that is equal in
          every token. Warranty is a labor contract while{space}
          <i>
            scheduling insurance scalps{space}
            <b>without</b>
            {space}a stop loss
          </i>
          . If you want to trade fully, you will store, transport, serve, or
          contribute.
          <div
            style={{
              padding: "10px",
              backgroundColor: "rgb(252, 255, 179)"
            }}
          >
            "[I]f you conduct an{space}
            <span style={{ color: "linen", backgroundColor: "rgb(80,60,170)" }}>
              immediate
            </span>
            {space}transaction among yourselves, then there is no need for you
            to record it, but call upon witnesses when a deal is finalized. Let
            no harm come to the scribe or witnesses. If you do, then you have
            gravely exceeded ˹your limits˺. Be mindful of Allah, for Allah ˹is
            the One Who˺ teaches you. And Allah has ˹perfect˺ knowledge of all
            things. (2:282)"
          </div>
          {space}A joint bank account is not immediate. you are surrendering the
          freedom in the stolen purchase lien for the right to own, and causing
          inflation if either expiring commodities or scalping schedules without
          a material stop-loss, and intractable, multi-level stock and bad
          advice.
          <span style={{ backgroundColor: "salmon", color: "white" }}>
            emergency doctors on the calendar{space}&bull;{space}​
            <a
              style={{ backgroundColor: "salmon", color: "white" }}
              href="https://thetax.party"
            >
              only medics
            </a>
          </span>
          <br />
          defer life to non profit teaching people or institutional gift
          <br />
          how does the anarchist confront the blessings of anyone but G-d? When
          isn't unemployment marginal? Is a marginal or absolute derivative a
          changing rate?
          <h4>(​emergency inpatient bills indemnity scheduling yeesh)</h4>
          warranty fraud (merchant escrow account, ​in all 50 state, ​i'm about
          to{space}
          <a style={{ color: "black" }} href="https://vau.money">
            act without a license
          </a>
          ) How do account transaction tax exemptions differ for life insurance
          and escrow merchant processors? Doesn't a life insurance policy work
          as a living will? Does it need to expire with non fiduciary depository
          inventory nor warranty indemnity consumer fraud or can the certificate
          issuer also be an outright either depositary or merchant processor?
          (​to be tax deferred you need to write a will with a licensed insurer)
          Cost of comfort. Can a merchant processing sole proprietor also serve
          as a board member?{space}
          <span style={{ color: "cadetblue" }}>
            Does an escrow account have the same tax deference privileges as a
            licensed life insurance agent can shim?
          </span>
          {space}If you are a software developer, would you work for an
          accounting firm or build a competitor?
          <br />
          <br />
          Literally take Financial Markets and Institutions with the description
          of the financial crisis and say debt service should be returned upon
          foreclosure and fail out.
          <br />
          <br />
          Do you want to be fucking nuts like Lawrence M. Ball? AIRU cannot be
          bad and GDP per capita nor real income growth good.
          <br />
          <br />
          Is the loss of labor outcomes worth the equalization of welfare?
          Doesn't income equalization include poverty disparity narrowing and
          not necessarily persistent currency capital nor durable good,
          equipment, and in-kind or market IP stock equalization?
          <br />
          <br />
          Is intractable or extractable unemployment due to loaned fiat debt
          money lending lease investment? Doesn't persistent either treasury per
          currency or stock growth cause either Kuznets curve income or
          deflationary inventory-lag equalization?
          <br />
          <br />
          Is the{space}
          <a style={{ color: "black" }} href="http://magnate.company">
            government holding back technology with grants
          </a>{" "}
          to already rich entrepreneurs to cause productivity growth?
          <br />
          <br />
          I'll be{space}
          <a style={{ color: "black" }} href="https//commie.dev/mod">
            anything
          </a>
          {space}you want me{space}
          <a style={{ color: "black" }} href="https://jester.com.co">
            to be
          </a>
          .<h4 style={{ margin: "4px 0px" }}>Marginal Education</h4>
          Isn’t poverty by expense implied by non-deflationary income growth
          instead of economical outcome from time and investment from shrink?
          <h3>
            u/WinPillSeeker anarchy (minarchy) is as much utopian as
            communism... libertarians are{space}
            <a style={{ color: "black" }} href="https://thumbprint.quora.com">
              minarchists
            </a>
            ...
          </h3>
          <a href="https://www.quora.com/Why-does-education-tuition-have-inelastic-demand/answer/Nick-Carducci">
            <Cable
              style={{ width: "100%", maxWidth: "50%" }}
              onError={handleScollImgError}
              img={true}
              src={
                this.state.noyout
                  ? ""
                  : "https://www.dropbox.com/s/q915lw19ig7q96d/price%20contraints%20with%20a%20rational%20and%20or%20coerced%20supply%20and%20a%20nominal%20cardinal%20price%20%282%29.png?raw=1"
              }
              float={"left"}
              title=""
              scrolling={this.state.scrolling}
              fwd={this["scrollImg" + scrollnum()]}
              scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
              scrollTop={this.state.scrollTop}
            />
          </a>
          <h4>
            Why would a rich country have better services?{space}
            <span style={{ color: "grey" }}>
              Doesn’t the marginal benefit rate of substitution for leisure
              occur at the NAIRU maxima? Doesn’t any more unemployment only
              inflate acceleratingly with unnatural social capital and otherwise
              individual use is marginal?
            </span>
            {space}
            Isn’t the non-accelerating inflation rate of unemployment where the
            marginal benefit rate of substitution for leisure is complementary
            to demand?{space}
            <i style={{ color: "cadetblue" }}>
              Isn’t your vote just as significant with a third party as with a
              major party? How is a third party vote thrown away when the
              two-party voters are just as significant, statistically? Isn’t
              voting third party throwing your vote away only if everyone thinks
              that? Does every two-party voter break the tie between the
              parties?
            </i>
            {space}Isn’t the marginal benefit rate of substitution for leisure
            generally deflationary as well as individually useful?{space}
            <span style={{ color: "navy" }}>
              Isn’t invested labor for the rich always non-deflationary
              marginally and inflationary for everyone else in total? How can a
              rich laborer be deflationary and useful?
            </span>
            {space}Doesn’t an accelerated inflation rate of unemployment make a
            potential accelerating deflation rate of employment?{space}
            <i style={{ color: "orange" }}>
              Isn’t a non-accelerating deflation rate of employment absolutely
              the non-accelerating inflation rate of unemployment? Aren’t the
              accelerations over realized productivity positively correlated
              with the job being service work?
            </i>
          </h4>
          <Cable
            style={{ width: "auto", height: "500px" }}
            onError={handleScollImgError}
            //img={true}
            src={
              this.state.noyout
                ? ""
                : "https://www.youtube.com/embed/dpAGack3BrY"
            }
            float={"right"}
            title="https://youtu.be/dpAGack3BrY"
            scrolling={this.state.scrolling}
            fwd={this["scrollImg" + scrollnum()]}
            scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
            scrollTop={this.state.scrollTop}
          />
          <h4>
            Ay caramba,{space}
            <a
              style={{ color: "black" }}
              href="https://huddleup.substack.com/p/how-do-professional-sports-leagues"
            >
              Desportes
            </a>
          </h4>
          That is to say, any particular machine may yield an income which is of
          the nature of a rent, and which is sometimes called a Rent; though on
          the whole, there seems to be some advantage in calling it a
          Quasi-rent. But we cannot properly speak of the interest yielded by a
          machine. If we use the term "interest" at all, it must be in relation
          not to the machine itself, but to its money value. (Alfred Marshall,
          {space}
          <i>
            Principles of Economics by Alfred Marshall, Book Two: Some
            Fundamental Notions Chapter 4, Income, Capital
          </i>
          , 1890)
          <br />
          <div
            style={{ padding: "10px", backgroundColor: "rgb(172, 235, 252)" }}
          >
            <h4 style={{ margin: "4px 0px" }}>Make products not prices</h4>
            But when the division of labour first began to take place, this
            power of exchanging must frequently have been very much clogged and
            embarrassed in its operations. One man, we shall suppose, has more
            of a certain commodity than he himself has occasion for, while
            another has less [and is the price-maker before the market is made].
            The former consequently would be glad to dispose of, and the latter
            to purchase, a part of this superfluity. But if this latter should
            chance to have nothing that the former stands in need of, no
            exchange can be made between them. (Adam Smith,{space}
            <i>
              Wealth of Nations, Book I: On the Causes of Improvement in the
              Productive Powers. On Labour, and on the Order According to Which
              its' Produce is Naturally Distributed Among the Different Ranks of
              the People: On the Origin and Use of Money
            </i>
            , 1776)
          </div>
          <br />
          Monetary theory has no ideological content. It deals with a scientific
          question—how a particular social contrivance works. It may surprise
          most readers to learn that, in today’s terminology, Karl Marx could be
          labeled a “monetarist”—a term that is currently, if incorrectly,
          regarded as almost synonymous with “conservative” or “pro free
          market.” (Milton Friedman, Marx and Money, 27 October 1980. p. The
          Newsweek/Daily Beast Company, p. 95; Hoover Inst.)
          <br />
          <br />
          layoffs will make deflation, better products will get ayoffs
          (technologsts do t seek m0ore problems; I'll take a mudpie to a non
          deflationary job and I will have ONE apple pie.
          <br />
          1. A RECESSION IS A fall of shrinkflation, benefits from essential
          institutions, and layoffs
          <br />
          if the economy settled would be property, what is the dollar vs bond
          <br />
          2. machine rent is how capital wedges labor
          {/*
          Supply and demand comp prices. A recession of less real GDP = shrink + benefits* + layoffs.
          *non-essential institutions need not apply.

          recession summation of machine
          */}
          <h3>Is G-d a woman and the devil an apprentice]” but for your 6</h3>
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            O’Prophet, tell your wives and your daughters and the women of the
            believers to draw their cloaks close round them (when they go
            abroad). That will be better, so that they may be recognised and not
            annoyed. Allah is ever Forgiving, Merciful. (Quran 33:59).
            <br />
            <br />
            The two angels never taught anyone without saying,{space}
            <i>
              ”We are only a test ˹for you˺, so do not abandon ˹your˺ faith.”
              Yet people
              {space}
              <b>learned ˹magic˺ that caused a rift</b>
              {space}˹even˺{space}
              <b>between husband and wife</b>; although their magic could not
              harm anyone except by Allah’s Will.
            </i>
            {space}They{space}
            <i>learned what harmed them</i>
            {space}and{space}
            <i>
              did not benefit them—although they already knew that whoever buys
              into magic would have no share in the Hereafter
            </i>
            . Miserable indeed was the price for which they sold their souls, if
            only they knew! (2:102)
          </div>
          <h1>Moral rent, disutility of labor, and tragedian art</h1>
          <h2>
            The Will to Gen (trump can have saverparty.xyz i'll take{space}
            <a href="https://thumbprint.quora.com">thetaxparty.com</a>
          </h2>
          Paul starts from the need for a mystery felt by the broad, religiously
          excited masses:{space}
          <a href="https://saverparty.xyz/jesus">he seeks a sacrifice</a>, a
          bloody phantas­ magoria which will stand up in competition with the
          images of the mystery cults: God on the cross, blood-drinking, the
          urtio mystica with the “sacrifice.” He seeks to bring the afterlife
          (the blissful, atoned afterlife of the individual soul) as
          resurrection into a causal relationship with that sacrifice (after the
          type of Dionysus, Mithras, Osiris). He needs to bring the concept
          guilt and atonement into the foreground, not a new way of life (as
          Jesus himself had demon­ strated and lived) but a new cult, a new
          faith, a faith in a miraculous transformation ( “redemption” through
          faith). He understood what the pagan world had the greatest need of,
          and from the facts of Christ’s life and death made a quite arbitrary
          selection, giving everything a new accentuation, shifting the emphasis
          everywhere—he annulled primitive Christianity as a matter or
          principle— The attempt to destroy priests and theologians culminated,
          thanks to Paul, in a new priesthood and theology—in a new ruling order
          and a church. The attempt to destroy the exaggerated inflation of the
          “person” culminated in faith in the “eternal person” (in concern for
          “eternal salvation”—), in the most paradoxical excess of personal
          egoism* This is the humor of the situation, a tragic humor: Paul re­
          erected on a grand scale precisely that which Christ had annulled
          through his way of living. At last, when the church was complete, it
          sanctioned even the existence of the state.
          <h2 style={{ margin: "4px 0px", backgroundColor: "rgb(22, 93, 49)" }}>
            <i style={{ color: "linen" }}>
              This Jesus of Nazareth, the incarnate gospel of love, this
              "Redeemer" bringing salvation and victory to the poor, the sick,
              the sinful-was he not really temptation in its most sinister and
              irresistible form, temptation to take the{space}
              <a
                style={{ color: "linen" }}
                href="https://www.quora.com/Do-Jews-believe-the-passage-Isaiah-53-7-including-for-the-transgression-of-my-people-was-he-stricken-predicts-dying-for-not-due-to-of-sin-or-did-Peter-ruin-the-Old-Testament-Do-Muslims-admit-Jesus-pbuh-committed"
              >
                tortuous path to those very Jewish values and those very Jewish
                ideals
              </a>
              ? (Yikes; how is this from Hebrew["-Arabic"]?)
            </i>
          </h2>
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            The angels said, “O Lot! We are the messengers of your Lord. They
            will never reach you. So travel with your family in the dark of
            night, and do not let any of you look back, except your wife. She
            will certainly suffer the fate of the others. Their appointed time
            is the morning. Is the morning not near?” (11:81)
            <br />
            <br />
            And ˹remember˺ Lot, when he rebuked ˹the men of˺ his people,{space}
            <i>
              “Do you commit that shameful deed while you can see ˹one another˺?
              {space}
              <b>
                Do you really lust after men instead of women? In fact, you are
                ˹only˺ a people acting ignorantly.”
              </b>
            </i>
            {space}
            But his people’s only response was to say, “Expel Lot’s followers
            from your land! They are a people who wish to remain chaste!”
            (27:54-56)
            <br />
            <br />
            {/*This sounds like public adultery.*/}
            Do not{space}
            <i>
              <b>go near</b>
              {space}adultery. It is truly a shameful deed
            </i>
            {space}and an evil way. (17:32)
            <br />
            <br />
            {/*Are sins shameful or are public shameful acts sinful?*/}
            Give women ˹you wed˺ their due dowries graciously. But if they waive
            some of it willingly, then you may enjoy it freely with a clear
            conscience. (4:4)
            <br />
            <br />
            And ˹remember˺ when Lot rebuked ˹the men of˺ his people:{space}
            <i>
              “You certainly commit a shameful deed that no man has ever done
              before you.{space}
              <b>
                Do you really lust after ˹other˺ men, abuse the travellers, and
                practice immorality ˹openly˺ in your gatherings?”
              </b>
            </i>
            {space}His people’s only response was to say ˹mockingly˺: “Bring
            Allah’s punishment upon us, if what you say is true.” (29:28-29)
          </div>
          <h3>
            "Capitalism isn't{space}
            <a style={{ color: "black" }} href="https://vau.money">
              coersively
            </a>
            {space}hiearchal."
          </h3>
          The problem is that capitalism was invented by Proudhon and capital by
          Smith. Ricardo, Malthus, and mostly J.B. say described{space}
          <span style={{ textDecoration: "line-through" }}>capitalists</span>
          {space}
          proprietors as those who pay for ground rent (Marx) and usufruct
          (Proudhon). Everyone thinks coercion is a disutility; especially
          forced investment without everyone having an E-Manifest FedCash
          account, to begin with. Isn’t debt a prisoners’ dilemma on personal
          essentials or general income? Isn’t duress void in contract law?
          Hierarchy can be rational when prices are discrimination only when
          profits{space}
          <b>
            <i>don't</i>
          </b>
          {space}exist to afford a market out of balance of ordinary revenue to
          cost, and maximize use to benefit. (edit: technically with academic
          works,{space}
          <b>capital is durable</b>
          {space}but affords one their revenue, and shared stock is the
          extension of this stock over others through an outright purchase
          {space}
          <i>
            otherwise, now I say a third party donee beneficiary recallable and
            restitution-able victim mentality and right
          </i>
          ;{space}
          <b>property</b>
          {space}is a deed explicitly because it isn't perishable{space}
          <b>nor destructible</b>
          {space}- capital has titles. Labor usually doesn't).
          <h3>Society-capital (destination?)</h3>
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            We will certainly test you with a touch of fear and famine and loss
            of{space}
            <i>property, life, and crops</i>. Give good news to those who
            patiently endure— (2:155) O  my people! Give full measure and weigh
            with justice.{space}
            <i>Do not defraud people of their property</i>, nor go about
            spreading corruption in the land.(11:85) Then if you feel they are
            capable of sound judgment, return their wealth to them. And do not
            consume it wastefully and hastily before they grow up ˹to demand
            it˺. If the guardian is well-off, they should not take compensation;
            but if the guardian is poor, let them take a reasonable provision.
            (4:6)
          </div>
          <i>
            Is the U.S. government's deficit spending growing and usual to begin
            with because non-voters aren't counted to reconcile budgeting?
          </i>
          <br />
          <br />
          A nihilistic religion [like Christianity], sprung from and appropriate
          to a people grown old and tame, having outlived all strong
          instincts—transferred step by step to another milieu, at length
          entering into youthful peoples which have not yet lived at all—very
          curious! The bliss of the close, the fold, the evening preached to
          barbarians and Germans! How thoroughly all that I first had to be
          barbarized, Germanized! To those who had dreamed a Valhalla: who found
          happiness only in war!—A su­ pranational religion preached in a chaos
          where no nations even existed yet—The only way to refute priests and
          religions is this: to show that their errors have ceased to be
          beneficial—that they rather do harm; in short, that their own “proof
          of power” no longer holds good—
          <br />
          <br />
          Nothing is further from Buddhism than the Jewish fanaticism of a Paul:
          nothing would be more repellent to its instincts than this tension,
          fire, un­ rest of the religious man, above all that form of sensuality
          that Christianity has sanctified with the name “love,” Moreover, it is
          the cultured and even the overspirited orders that find satisfaction
          in Buddhism: a race satiated and wearied by centuries of philo­
          sophical contentions, not, however, beneath all culture, like the
          {space}
          <span style={{ backgroundColor: "navy", color: "white" }}>
            <a style={{ color: "white" }} href="https://marginalism.uk/classes">
              classes
            </a>
            {space}from which Christianity arose— Emancipation even from good
            and evil appears to be of the essence of the Buddhist ideal: a
            refined state beyond morality is conceived that is identical with
            the state of perfection, in the presupposition that one needs to
            perform even good actions only for the time being, merely as a
            means—namely, as a means to emancipation from all actions.
          </span>
          <h1>"Faith" or "works"?</h1>— But that "works,” the habit of certain
          works, should engender a certain evaluation and finally a certain
          disposition is as natural as it is unnatural that mere evaluation
          should produce “works.” One must practice deeds, not the strength­
          ening of one’s value-feelings; one must first have some ability— The
          Christian dilettantism of Luther. Faith is a pons asinorum.u The
          background is a profound conviction on the part of Luther and his kind
          of their incapacity for Christian works, a personal fact disguised
          beneath an extreme doubt as to whether activity of all kinds is not
          sin and the work of the Devil: so that the value of existence resides
          in single highly tensed conditions of inactivity (prayer, effusion,
          etc.),— In the last resort he was right: the in­ stincts expressed in
          all the actions of the Reformers are the most brutal that exist. Only
          by an absolute turning away from them­ selves, by absorption in their
          opposite, only as an illusion (“faith”) was existence endurable to
          them.
          <br />
          <br />I like not the agitators dressed up aslieroes, who hide their
          dummy-heads behind the stalking-horse of an ideal; I like not the
          ambitious artists who would fain play the ascetic and the priest, and
          are at bottom nothing but tragic clowns; I like not, again, these
          newest speculators in idealism, the Anti-Semites, who nowadays roll
          their eyes in the patent Christian-Aryan-man-of- honour fashion, and
          by{space}
          <i>
            an abuse of{space}
            <a style={{ color: "black" }} href="https://commie.dev/anarchy">
              moralist
            </a>
            {space}attitudes and agitation dodges, so cheap as to exhaust any
            patience
          </i>
          , strive to excite all the{space}
          <a
            style={{ color: "black" }}
            href="https://reddit.com/r/moralanarchism"
          >
            blockhead
          </a>
          {space}elements in the populace.
          <br />
          <br />
          We have in our hands the possibility of idealising the whole earth.
          But what am I talking about courage? we only need one thing here-a
          hand, a free, a very free hand.
          <br />
          <br />
          Christianity has from the outset transformed the symbolic into
          crudities: … 3. brotherhood on the basis of sharing food and drink
          together after the Hebrew-Arabic custom, as ‘the miracle of
          transubstantiation’;” (Will to Power, p. 102, 1888)
          <br />
          <br />
          There are only sins against God; men shall not judge acts done against
          men, nor demand a reckoning, except in the name of God.
          <h2>
            Did Judaism come before Hebrew or is the religion written-first?
          </h2>
          <span style={{ backgroundColor: "darkslategray", color: "white" }}>
            The state of nature is terrible, man is a beast of prey; our
            civilization represents a tremendous triumph over this beast-of-prey
            nature: thus argued Voltaire.{space}
            <i style={{ color: "lightsteelblue" }}>
              He felt the mitigation, the subtleties, the spiritual joys of the
              civilized state; he despised narrowmindedness, also in the form of
              virtue, and the lack of delicatesse, also among ascetics and
              monks.
            </i>
            {space}
            <span style={{ color: "gainsboro" }}>
              The moral reprehensibility of man seemed to preoccupy Rousseau;
              with the words “unjust” and “cruel” one can best stir up the
              instincts of the oppressed who otherwise smart under the ban of
              the{space}
              <i>vetitum</i>
              {space}and disfavor, so their conscience advises them against
              rebellious cravings. Such emancipators seek one thing above all:
              to give their party the grand accents and poses of the higher
              nature.
            </span>
          </span>
          <br />
          <br />
          Rousseau: the rule based on feeling; nature as the source of justice;
          man perfects himself to the extent to which he approaches nature
          (according to Voltaire, to the extent to which he moves away from
          nature). The very same epochs are for one ages of the progress of
          humanity; for the other, times when injustice and inequality grow
          worse. Voltaire still comprehended umanita in the Renaissance sense;
          {space}
          <span style={{ color: "lightskyblue", backgroundColor: "cadetblue" }}>
            There is nothing better than what is good— and good is having some
            ability and using that to create,{space}
            <i>Tuchtigkeit</i>
            {space}(or{space}
            <i>virtu</i>, in the Italian Renaissance sense, as “high culture”);
            he fights for the cause of the “<i>honnetes gens</i>" and "
            <i>de la bonne compagnie</i>“ the cause of taste, of science, of the
            arts, of progress itself and civilization. The fight began around
            1760: the citizen of Geneva and le seigneur de Ferney. Only from
            that moment on Voltaire becomes the man of his century, the
            philosopher, the representative of tolerance and unbelief (till then
            merely{space}
            <i>un bel esprit</i>) Envy and hatred of Rousseau’s success impelled
            him forward, “
            <a href="https://ia803205.us.archive.org/27/items/FriedrichNietzscheTheWillToPower/Friedrich%20Nietzsche%20-%20The%20Will%20to%20Power.pdf#page=97">
              to the heights
            </a>
            .”
          </span>
          <h2>
            Moralistic naturalism: the tracing back of apparently emanci­ pated,
            supranatural moral values to their “nature”: i.e., to natural
            immorality, to natural “utility,” etc.
          </h2>
          <h3>
            I might designate the tendency of these reflections as moral­ istic
            naturalism:{space}
            <span style={{ backgroundColor: "darkslategray", color: "white" }}>
              my task is to translate the apparently emancipated and denatured
              moral values{space}
              <i>
                back into their nature—i.e., into their natural “immorality.”
              </i>
            </span>
          </h3>
          <h4>
            <a href="https://saverparty.xyz/jesus">Jesus</a>
            {space}(run!) starts directly with the condition the “Kingdom of
            Heaven” in the heart, and he does not find the means to it in the
            observances of the Jewish church; the reality of Judaism itself (its
            need to preserve itself) he regards as nothing; he is purely
            inward.—{space}
            <i style={{ color: "grey" }}>
              He likewise ignores the entire system of crude formalities
              governing intercourse with God: he opposes the whole teaching of
              repentance and atonement; he demonstrates how one must live in
              order to feel “deified”—and how one will not achieve it through
              repentance and contrition for one’s sins: “Sin is of no account”
              is his central judgment. Sin, repentance, forgiveness—none of this
              belongs here—it is acquired from Judaism, or it is pagan.
            </i>
            {space}
            <span
              style={{
                fontSize: "12px",
                backgroundColor: "indigo",
                color: "gold"
              }}
            >
              Attempt by antipaganism to found and make itself possible
              philosophically: predilection for the ambiguous figures Of the old
              culture, above all for Plato, that instinctive Semite and
              anti-Hellene —also for Stoicism, which is essentially the work of
              Semites (
              <i>
                —“dignity” as strictness, law, virtue as greatness,
                self-responsi­bility, authority, as supreme sovereignty over
                one’s own person— this is Semitic.
              </i>
              {space}The Stoic is an Arabian sheik wrapped in Greek togas and
              concepts)
            </span>
            <br />
            This is the humor of the situation, a tragic humor: Paul re­-erected
            on a grand scale precisely that which Christ had annulled through
            his way of living. At last, when the church was complete, it
            sanctioned even the existence of the state.
            <br />
            <span
              style={{
                fontSize: "12px",
                backgroundColor: "firebrick",
                color: "white"
              }}
            >
              Jesus starts directly with the condition the “Kingdom of Heaven”
              in the heart, and he does not find the means to it in the
              observances of the Jewish church; the reality of Judaism itself
              (its need to preserve itself) he regards as nothing; he is purely
              inward.— He likewise ignores the entire system of crude
              formalities governing intercourse with God: he opposes the whole
              teaching of repentance and atonement; he demonstrates how one must
              live in order to feel “deified”—and how one will not achieve it
              through repentance and contrition for one’s sins: “Sin is of no
              account” is his central judgment. Sin, repentance,
              forgiveness—none of this belongs here—it is acquired from Judaism,
              or it is pagan.
            </span>
            <h3
              style={{
                margin: "4px 0px"
              }}
            >
              jester.com.co
            </h3>
            <div
              style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
            >
              By the grace of your Lord, you ˹O Prophet˺ are not insane. You
              will certainly have a never-ending reward. And you are truly ˹a
              man˺ of outstanding character. Soon you and the pagans will see,
              which of you is mad. Surely your Lord ˹alone˺ knows best who has
              strayed from His Way and who is ˹rightly˺ guided. So do not give
              in to the deniers. They wish you would compromise so they would
              yield ˹to you˺. (Hadith 68:2-9)
            </div>
            {/*I like not the agitators dressed up as heroes, who hide their
            dummy-heads behind the stalking-horse of an ideal; I like not the
            ambitious artists who would fain play the ascetic and the priest,
            and are at bottom nothing but tragic clowns; I like not, again,
            these newest speculators in idealism, the Anti-Semites, who nowadays
            roll their eyes in the patent Christian-Aryan-man-of-honour fashion,
            and by an abuse of moralist attitudes and agitation dodges, so cheap
            as to exhaust any patience, strive to excite all the blockhead
            elements in the populace.
            <br />*/}
            <span
              style={{
                fontSize: "12px",
                backgroundColor: "darkviolet",
                color: "white"
              }}
            >
              An apostasy and reversion to the morbid Christian and obscurantist
              ideals? And finally a self-negation and self-elimination on the
              part of an artist, who till then had devoted all the strength of
              his will to the contrary, namely, the highest artistic expression
              of soul and body. And not only of his{space}
              <a style={{ color: "white" }} href="https://wavv.art">
                art
              </a>
              ; of his life as well.
              <br />
              That, as I have said, would have been quite worthy of a great
              tragedian; who like every artist first attains the supreme
              pinnacle of his greatness when he can look down into himself and
              his art, when he can laugh at himself.
            </span>
            <br />
            <br />
            <span
              style={{
                fontSize: "12px",
                backgroundColor: "cadetblue",
                color: "white"
              }}
            >
              [O]ur old morality too is fit material{space}
              <i>for Comedy</i>[. We] have discovered a new plot, and a new
              possibility for the Dionysian drama entitled{space}
              <i>The Soul's Fate</i>-and he will speedily utilise it, one can
              wager safely, the, the great ancient eternal dramatist of the
              comedy of our existence.
            </span>
            <br />
            <br />
            Science—this has been hitherto a way of putting an end to the
            complete confusion in which things exist, by hypotheses that
            “explain” everything—so it has come from the intellect’s dislike of
            chaos.— This same dislike seizes me when I consider myself: I should
            like to form an image of the inner world, too, by means of some
            schema, and thus triumph over intellectual confusion. Morality has
            been a simplification of this kind: it taught that men were known,
            familiar.— Now we have destroyed morality—we have again become
            completely obscure to ourselves! I know that I know nothing of
            myself. Physics proves to be a boon for the heart: science (as the
            way to knowledge) acquires a new charm after morality has been
            eliminated—and because it is here alone that we find consistency, we
            have to construct our life so as to preserve it. This yields a sort
            of practical reflection on the con­ ditions of our existence as men
            of knowledge.
          </h4>
          Nietzsche was interested in the value of life not the non-immoral
          morale impediments. He (Nietzsche, as a nothing) considered anarchists
          as destructive to value.
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 195, 179)" }}
          >
            No bitterness or empty hate dictated his vituperations against
            existing values and against the dogmas of his parents and
            forefathers. He knew too well what these things meant to the
            millions who profess them, to approach the task of uprooting them
            with levity or even with haste.{space}
            <a href="https://www.gutenberg.org/files/1998/1998-h/1998-h.htm">
              Those who hastily class him with the anarchists
            </a>
            {space}(or the Progressivists of the last century) fail to
            understand the high esteem in which he always held both law and
            discipline. In verse 41 of this most decisive discourse he truly
            explains his position when he says: “...he who hath to be a creator
            in good and evil—verily he hath first to be a destroyer, and break
            values in pieces.” This teaching in regard to self-control is
            evidence enough of his reverence for law. (Friedrich Nietzsche,
            {space}
            <i>
              Thus Spake Zarathustra "A Book for All and None", Chapter XXXIV:
              Self-Surpassing, Chapter LVI: Old and New Tables. Par. 2.
            </i>
            , 1883-92)
          </div>
          I wish I could find a compliment as he does sometimes in critiques,
          lets just look for his mentions of usufructuary and or responsibility:
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 195, 179)" }}
          >
            No one doubted that all the antecedentia of an action were to be
            sought in consciousness, and could be discovered there—as
            “motive”—if only they were sought. Otherwise we should not be free
            to perform them, we should{space}
            <a href="https://www.gutenberg.org/cache/epub/58025/pg58025-images.html">
              not
            </a>
            {space}have been responsible for them. (Friedrich Nietzsche,{space}
            <i>The Twilight of the Idols: The Four Great Errors: 3</i>, 1911)
          </div>
          Anarchy means there is no hierarchy because of the individual use of
          the usufructuary, and technological based margin gains with steady
          prices will not come without action against the state without a test
          of right and where compulsory will voids all liberal rewards of labor
          and trade.
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 195, 179)" }}
          >
            <a
              style={{ color: "black" }}
              href="https://theanarchistlibrary.org/library/pierre-joseph-proudhon-what-is-property-an-inquiry-into-the-principle-of-right-and-of-governmen"
            >
              Competition
            </a>
            , sometimes called{space}
            <i>liberty of trade</i>
            {space}[Ricardo], —{space}
            <a href="https://bankingisnot.biz">in a word</a>, property in
            exchange, — will be for a long time the basis of our commercial
            legislation; which, from the economical point of view, embraces all
            civil laws and all government. (Pierre-Joseph Proudhon,{space}
            <i>
              What is Property? An Inquiry into the Principle of Right and of
              Government
            </i>
            , 1840)
          </div>
          <a
            style={{ color: "black" }}
            href="https://comlib.quora.com/What-is-an-anarchist-libertarian-1"
          >
            Doesn't existentialism accentuate life for values from morals
          </a>
          ?
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            Their reward is forgiveness from their Lord and Gardens under which
            rivers flow, staying there forever. How excellent is the reward for
            those who work ˹righteousness˺! (3:136)
            <br />
            <br />
            Whoever of them were to say, “I am a god besides Him,” they would be
            rewarded with Hell by Us. This is how We reward the wrongdoers.
            (21:29)
          </div>
          <i style={{ color: "cadetblue" }}>
            My two cent benefit make reflecting this is why the shahada is there
            is No G-d but Allah and Muhammad is His prophet (pbuh). So then the
            {space}
            <a style={{ color: "black" }} href="https://reddit.com/r/hadithes">
              purpose
            </a>
            {space}I will leave to other hopeful scholars. I don’t want to
            {space}
            <a
              style={{ color: "black" }}
              href="https://reddit.com/r/islamicbanks"
            >
              abrogate
            </a>
            {space}too much. It’s just reasonable for His intent so then what
            else.
          </i>
          {space}
          <b>
            I do believe Greeks has an idea of the pantheon as a testing ground
            for policy
          </b>
          , and we know…
          {space}
          <a
            style={{ color: "black" }}
            href="https://truncatedwholesaletax.com"
          >
            wait a minute
          </a>
          :
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            Do you ˹O Prophet˺ not see that We have sent the devils against the
            disbelievers, constantly inciting them? (19:83)
            <div
              style={{
                border: "4px solid lightslategrey",
                backgroundColor: "navy",
                color: "silver",
                padding: "4px",
                fontSize: "12px",
                margin: "10px 2px"
              }}
            >
              I must contend with this notion: Gambling is haram because you get
              rich quickly, and this is deemed to be an incomplete measure,
              however, capital gains are to recover a loss that which borders
              between nations and{space}
              <span
                style={{ color: "linen", backgroundColor: "rgb(80,60,170)" }}
              >
                intertemporal either{space}
                <a
                  style={{ color: "linen" }}
                  href="https://multilevelcapital.com"
                >
                  advance
                </a>
              </span>
              {space}or{space}
              <a style={{ color: "linen" }} href="https://bankingisnot.biz">
                invoice
              </a>
              {space}starts, principally, setting aside riba. saverparty.xyz
            </div>
            And from the fruits of the palm trees and grapevines you take
            intoxicant and good provision. (An-Nahl 16:67)
          </div>
          To not fight back against financiers, is as much haram as continuing
          to trade while losing.
          <div
            style={{ padding: "10px", backgroundColor: "rgb(252, 255, 179)" }}
          >
            Have you not seen those chiefs of the Children of Israel after
            Moses? They said to one of their prophets, “Appoint for us a king,
            ˹and˺ we will fight in the cause of Allah.” He said, “Are you not
            going to cower if ordered to fight?” They replied, “How could we
            refuse to fight in the cause of Allah, while we were driven out of
            our homes and ˹separated from˺ our children?” But when they were
            ordered to fight, they fled, except for a few of them. And Allah has
            ˹perfect˺ knowledge of the wrongdoers. (2:246)
          </div>
        </div>
      );
    } else if (this.state.onVaumoney) {
      return (
        <div
          style={{
            border: "1px solid rgb(200,200,200)",
            overflow: "hidden",
            //margin: "5px",
            fontFamily: "'Comfortaa', cursive",

            wordBreak: "break-word",
            textAlign: "left",
            width: "100%",
            maxWidth: "600px",
            position: "relative",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              position: "fixed", //salt bank vaults royalty stewardship
              right: "0px", //living commodities at the equator
              top: "0px",
              cursor: "pointer"
            }}
            onClick={() => this.setState({ onVaumoney: false })}
          >
            vau.money
          </div>
          <h4 ref={this.cops} style={{ margin: "4px 0px" }}>
            Do cops vote?
          </h4>
          I think only the developmentally disabled and/or injured should
          receive{space}
          <a href="https://2024nj.com/disability">SSDI</a>.
          <br />
          <i>
            For every one who has any idea of the life of the labouring classes
            it is evident that without{space}
            <a href="https://www.reddit.com/r/moralanarchism/comments/ynkqmk/comparing_and_contrasting_bookchin_and_kropotkin/">
              mutual aid being practised
            </a>
            {space}among them on a large scale they never could pull through all
            their difficulties. It is only by chance that a worker’s family can
            live its lifetime without having to face such circumstances as the
            crisis described by the ribbon weaver, Joseph Gutteridge, in his
            autobiography. And if all do not go to the ground in such cases,
            {space}
            <a href="https://theanarchistlibrary.org/library/petr-kropotkin-mutual-aid-a-factor-of-evolution">
              they owe it to mutual help. In Gutteridge’s case it was an old
              nurse, miserably poor herself, who turned up at the moment when
              the family was slipping towards a final catastrophe, and brought
              in some bread, coal, and bedding, which she had obtained on
              credit.
            </a>
            {space}
            In other cases, it will be some one else, or the neighbours will
            take steps to save the family. But without some aid from other poor,
            how many more would be brought every year to irreparable ruin!
          </i>
          <br />
          <i>
            <b>
              Ah yes,{space}
              <a href="https://www.un.org/en/genocideprevention/documents/atrocity-crimes/Doc.15_supplementary%20slaverytrade.pdf#page=3">
                usufructuary rights
              </a>
            </b>
            /material duty
          </i>
          <br />
          <i>
            The day on which, in consequence of the development of the
            revolutionary situation, the governments are swept out by the people
            and disorganization is created in the ranks of the bourgeoisie who
            can only survive through the protection of the State, the insurgent
            people will not wait for any old government in its marvelous wisdom
            to decree economic reforms. They will abolish individual property by
            themselves taking possession, in the name of the whole people and by
            violent expropriation of the whole of social wealth which had been
            accumulated by the work of past generations.{space}
            <a href="https://www.marxists.org/reference/archive/kropotkin-peter/1885/words-of-a-rebel/chapter11.html">
              They will not stop short at expropriating the owners of social
              capital by a decree that will remain a dead letter; they will take
              possession and establish their rights of usufruct immediately.
            </a>
            {space}
            They will organize the workshops so that they continue production.
            They will exchange their hovels for healthy habitations in the
            houses of the well-todo; they will immediately find ways of
            utilizing the riches accumulated in the cities; they will take
            possession of it as if all this wealth had never been stolen from
            them by the bourgeoisie. Once the industrial baron who seized his
            booty from the worker has been evicted, production will continue,
            shaking off the fetters that hinder it, abolishing the speculations
            that kill it, getting rid of the muck that hinders its development,
            and changing it according to the needs of the moment under the
            impetus provided by freedom of work.
          </i>
          <div
            style={{
              position: "fixed", //salt bank vaults royalty stewardship
              right: "0px", //living commodities at the equator
              bottom: "0px",
              cursor: "pointer"
            }}
            onClick={() => this.setState({ onFactors: true })}
          >
            factors
          </div>
        </div>
      );
    } else
      return (
        <div
          style={{
            border: "1px solid rgb(200,200,200)",
            overflow: "hidden",
            //margin: "5px",
            fontFamily: "'Comfortaa', cursive",

            wordBreak: "break-word",
            textAlign: "left",
            width: "100%",
            maxWidth: "600px",
            position: "relative"
          }}
        >
          Aren’t contracts surrendered? Isn't a contract legal until proven
          otherwise?
          <h2>
            How many apple pies? Every apple pie is getting more expensive{" "}
          </h2>
          Geometric disutility production factors' possibility is twice
          deflationary and diminishing otherwise (one at a time)
          <br />
          <br />
          Isn't marginalism the thread of the individual? The geometric
          proportional mean is aside from arithmetic but for whole pairs between
          units instead of one type. The cardinal slope matrix inside ordinal
          individuals is all but a null-point and so its negation takes a
          non-deflationary supply.
          <br />
          <br />
          <a href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Physical_imports_and_exports#Physical_trade_by_stage_of_manufacturing">
            <Cable
              style={{ width: "100%" }}
              onError={handleScollImgError}
              img={true}
              src={
                this.state.noyout
                  ? ""
                  : "https://www.dropbox.com/s/gdn9zrc8fia203c/Physical%20material%20trade%20goods%20EU%202000-21.png?raw=1"
              }
              float={"right"}
              title=" https://ec.europa.eu/eurostat/statistics-explained/index.php?title=File:Physical_trade_of_goods_by_main_material_category_and_monetary_trade_of_goods,_EU,_2000-21.png"
              scrolling={this.state.scrolling}
              fwd={this["scrollImg" + scrollnum()]}
              scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
              scrollTop={this.state.scrollTop}
            />
          </a>
          <a href="https://www.quora.com/How-can-one-argue-with-Marx-although-I-am-not-a-Marxist-that-many-interests-of-both-blue-and-white-collar-labor-are-diametrically-opposed-to-those-of-Capital-in-that-Capital-wants-to-pay-least-for-labor-while-labor/answer/Nick-Carducci">
            fdi+import
          </a>
          {/**rich salt */}
          {space}={space}
          <a href="https://saverparty.xyz/poverty">developed</a>
          <br />
          <br />
          <i>
            social insurance as production has it is no insurance (induction of
            non-extractibly-pyramid ponzi scheme)
          </i>
          <br />
          52% 39% 15%
          <br />
          <br />
          (Assuming they overlap) are you one of the 67% pro-immigration, 39%
          ban private-insurance (for universal), 95% occupy wall street
          non-voters?
          <br />
          <br />
          don't non voters want to be{space}
          <a href="https://nonvoters.quora.com">hated</a>?
          {/**war or butter! (commie.dev/police) real inflation smol biz - inflationary job non-
        
        ​one man's non-deflationary job is another man's real inflation giving money away
        

        Ah yes, if you fight fire with fire the whole world turns ablaze.

        I would therefore prefer to burn Property by a slow fire, rather than give it new 
        strength by making a St Bartholomew’s night of the proprietors.

        Truly there is no hope for you. Be gone devil ape!
        */}
          <br />
          <br />
          <i>
            Why does the right wing say a majority of people want to decrease
            immigration when 52% Republicans, 67% Independents/non-voters, and
            83% Democrats don’t?
          </i>
          <br />
          <hr ref={this.utility} />
          Isn't the Jevons' paradox{space}
          <a href="https://comlib.quora.com/Isnt-the-Jevons-paradox-bonkers-1">
            bonkers
          </a>
          ?
          <br />
          In economics, the Jevons paradox (/ˈdʒɛvənz/; sometimes Jevons effect)
          occurs when technological progress or government policy increases the
          efficiency with which a resource is used (reducing the amount
          necessary for any one use), but the falling cost of use increases its
          demand, negating reductions in resource use.
          <br />
          <br />
          As american as apple{space}
          <a href="https://commie.dev">pie</a>. perpetually more cookies with
          perpetually more expensive recipes pulled from the public{space}
          <a href="https://commie.dev/domain">domain</a>
          <br />
          <br />
          Implausible (cannot) use more than one yacht (give it a rest), Oh
          Prophet! How capital will pay the most and consume the most if the
          market is made and prices are the same.
          <br />
          <br />
          <div style={{ backgroundColor: "salmon" }}>
            Only sellers and market makers know unless you discount price
            changes for volume, albeit this is subject to spoofing/painting tape
            by said market makers (for propaganda purposes). I’m not sure how
            disparaging this actually is from real price to volume balance.
          </div>
          <h4>
            Donkey and elephant will do anything for a marginal apple pie{space}
            <span role="img" aria-label="squirrel">
              🐿
            </span>
            {space}we diminish marginal utility.{space}
            <span style={{ color: "cadetblue" }}>
              Why does Mark Levin blame{space}
              <a href="https://crime-data-explorer.fr.cloud.gov/pages/explorer/crime/shr">
                illegal
              </a>
              {space}immigration for rape?
            </span>
            {space}
            <i>Do you think Social Security causes youth to commit crime?</i>
            <a href="https://www.ssa.gov/oact/ProgData/tsOps.html">
              <Cable
                style={{ width: "100%" }}
                onError={handleScollImgError}
                img={true}
                src={
                  this.state.noyout
                    ? ""
                    : "https://www.dropbox.com/s/8q8x8tw7rszq2q2/Screen%20Shot%202022-10-31%20at%208.58.03%20PM.png?raw=1"
                }
                float={"right"}
                title="tsOps - https://www.ssa.gov/oact/ProgData/tsOps.html"
                scrolling={this.state.scrolling}
                fwd={this["scrollImg" + scrollnum()]}
                scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
                scrollTop={this.state.scrollTop}
              />
            </a>
            <a href="https://www.ssa.gov/oact/ProgData/assets.html">
              <Cable
                style={{ width: "100%" }}
                onError={handleScollImgError}
                img={true}
                src={
                  this.state.noyout
                    ? ""
                    : "https://www.dropbox.com/s/sukvhn4qlhb0eoj/Screen%20Shot%202022-10-31%20at%208.56.57%20PM.png?raw=1"
                }
                float={"right"}
                title="assets - https://www.ssa.gov/oact/ProgData/assets.html"
                scrolling={this.state.scrolling}
                fwd={this["scrollImg" + scrollnum()]}
                scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
                scrollTop={this.state.scrollTop}
              />
            </a>
          </h4>
          <div
            style={{
              position: "fixed", //salt bank vaults royalty stewardship
              right: "0px", //living commodities at the equator
              bottom: "0px",
              cursor: "pointer"
            }}
            onClick={() => this.props.setBasic()}
          >
            more
          </div>
          <div
            style={{
              position: "fixed", //salt bank vaults royalty stewardship
              right: "0px", //living commodities at the equator
              top: "0px",
              cursor: "pointer"
            }}
            onClick={() => this.setState({ onVaumoney: true })}
          >
            why?
          </div>
          {/**
        
            <Cable
              style={{
                boxShadow: "0px 0px 0px 0px transparent",
                width: "100px",
                transform: "scale(-1,1)"
              }}
              onError={handleScollImgError}
              img={true}
              src={
                this.state.noyoutube
                  ? ""
                  : "https://www.dropbox.com/s/zgceu1uen2ov9n1/transparentSaverAcorn.png?raw=1"
              }
              float={null}
              title="author"
              scrolling={this.state.scrolling}
              fwd={this.henri}
              scrollTopAndHeight={this.state.scrollTop + window.innerHeight}
              scrollTop={!this.state.oldecon ? 0 : this.state.scrollTop}
            /> */}
        </div>
      );
  }
}
